<template slot-scope="scope">
      <dialogModel
        :title="Title"
        :visible.sync="dialogUpload"
        @handleClose="handleCloseUpload"
        @handleOk="handleUpload"
      >
        <div>
          <div class="Upload-box" v-loading="loading">
            <input
              type="file"
              ref="clearFile"
              @change="onFileChange"
              id="file"
            />
            <input
              type="button"
              value="点击上传"
              class="btn firm-clickable"
              @click="clickFile(1)"
            />
            <p>支持JPG、PNG格式 ，大小不得超过10M</p>
          </div>
          <div class="IMGEcho">
            <!-- 之前已上传的图片 -->
            <div
              class="imgBox"
              v-for="(item, index) in imgSrcArr"
              :key="index"
            >
              <img :src="item" alt="" />
              <div class="deleIcon firm-clickable" @click="handelDele(index)"></div>
            </div>
            <!-- 新上传的图片 -->
            <div
              class="imgBox"
              v-for="(item1, index1) in AddImgSrcArr"
              :key="index1"
            >
              <img :src="item1" alt="" />
              <div class="deleIcon firm-clickable" @click="handelDeleNew(index1)"></div>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>

export default {
  props: {
    dialogUpload: {},
    Title: {},
    Attachment: {}, //要回显的合同/简历图片
    isTitle:false
  },
  components: {},
  data() {
    return {
      loading: false,
      imgSrcArr: [], // 原本已有的图片路径集合
      docIdArr: [], // 原本已有的id集合

      imgSrc: "",

      AddImgSrcArr: [], // 新添加的图片路径集合
      AddDocIdArr: [], // 新添加项的id集合

      DeletedArr: [], // 原本已有且被删除项的id集合
    };
  },
  // 监听
  watch: {
    dialogUpload: {
      handler(newSs, old) {
        this.docIdArr = [];
        this.imgSrcArr = [];
        if (this.Title == "简历") {
          for (var i in this.Attachment.resumeList) {
            this.docIdArr[i] = this.Attachment.resumeList[i].docId;
            this.imgSrcArr[i] = this.Attachment.resumeList[i].docPath; //暂时没有图片路径字段
          }
        } else if (this.Title == "劳动合同") {
          for (var i in this.Attachment.contractList) {
            this.docIdArr[i] = this.Attachment.contractList[i].docId;
            this.imgSrcArr[i] = this.Attachment.contractList[i].docPath; //暂时没有图片路径字段
          }
        } else {
          this.docIdArr = [];
          this.imgSrcArr = [];
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    // 点击上传
    clickFile() {
      const input = document.querySelector("#file");
      input.click();
    },
    // 调用上传文件/图片封装的js
    // 正面
    async onFileChange(event, opt, callback) {
      if (this.docIdArr.length + this.AddDocIdArr.length < 1) {
        this.loading = true;
        var file = event.target.files[0] || event.dataTransfer.files[0];
        var fileSuffix1 = file.name;
        var fileArr = fileSuffix1.split(".");
        var fileSuffix = fileArr[fileArr.length - 1]; // 获取上传文件的后缀确认是否符合要求
        if (fileSuffix == "jpg" || fileSuffix == "png") {
          let URL = window.URL || window.webkitURL; // 当前地址
          this.imgSrc = URL.createObjectURL(file); // 转成 blob地址  用于上传后图片在页面中回显

          var arr = await this.$tool.onFileChangeNew(event, opt, callback);
          console.log(arr, "arr");
          if (arr.code == 0) {
            this.loading = false;
            var obj = {
              docId: arr.docId,
              docPath: arr.TXurl,
            };
            this.AddDocIdArr.push(obj);
            this.AddImgSrcArr.push(this.imgSrc);
          } else {
            this.loading = false;
          }
          this.$refs.clearFile.value = ""; // 清空file文件
        } else {
          // 上传文件不符合要求
          this.loading = false;
          this.$tool.PromptBox("error", "请上传jpg/png文件");
        }
      } else {
        this.$tool.PromptBox("error", "最多上传1张");
      }
    },
    // 删除已上传/正在队列中的图片
    handelDele(index) {
      this.DeletedArr.push(this.docIdArr[index]); //保存老图片被删除项的id  调接口时使用
      this.docIdArr.splice(index, 1);
      this.imgSrcArr.splice(index, 1);
    },
    //删除新上传的图片
    handelDeleNew(index1) {
      this.AddDocIdArr.splice(index1, 1);
      this.AddImgSrcArr.splice(index1, 1);
    },
    // 取消 关闭弹窗
    handleCloseUpload() {
      this.$emit("handleCloseUpload");
      this.imgSrcArr = []; // 原本已有的图片路径集合
      this.docIdArr = []; // 原本已有的id集合
      this.imgSrc = "";
      this.AddImgSrcArr = []; // 新添加的图片路径集合
      this.AddDocIdArr = []; // 新添加项的id集合
      this.DeletedArr = []; // 原本已有且被删除项的id集合
    },

    // 确认
    handleUpload() {
      // 传回 新增项id集合  老图被删除项ID集合
      this.$emit("handleUpload", this.AddDocIdArr, this.DeletedArr);
      this.imgSrcArr = []; // 原本已有的图片路径集合
      this.docIdArr = []; // 原本已有的id集合
      this.imgSrc = "";
      this.AddImgSrcArr = []; // 新添加的图片路径集合
      this.AddDocIdArr = []; // 新添加项的id集合
      this.DeletedArr = []; // 原本已有且被删除项的id集合
    },
  },
};
</script>

<style scoped lang="less">

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.Upload-box {
  border: 1px dashed #409eff ;
  width: 600px;
  height: 70px;
  background: #ffffff;
  border-radius: 5px;
  margin: 0 auto;

  #file {
    display: none;
  }
  #file1 {
    display: none;
  }
  input {
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    width: 100%;
    text-align: center;
    color: #409eff ;
    margin-top: 20px;
  }
  p {
    width: 100%;
    text-align: center;
    font-size: 10px;
  }
}
.IMGEcho::-webkit-scrollbar {
  display: none;
}
.IMGEcho {
  width: 600px;
  margin: 0 auto;
  height: 450px;
  margin-top: 30px;
  overflow: hidden;
  overflow-y: scroll;
  // 火狐隐藏滚动条
  scrollbar-width: none;
  display: flex;
  flex-wrap: wrap;
  .imgBox {
    width: 107px;
    height: 136px;
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  img {
    width: 107px;
    height: 136px;
  }
  .deleIcon {
    width: 15px;
    height: 15px;
    background-image: url("../../../../../assets/imgs/shanchu@3x.svg");
    background-size: 100% 100%;
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
